import React, {useEffect} from 'react';
import {useAddAdminForm} from '../../model';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';

interface AddAdminModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const AddAdminModal = ({open, setOpen}: AddAdminModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useAddAdminForm({setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Администратор',
    title: 'Ошибка при добавлении администратора',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  // Очистка формы при открытии модального окна
  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Добавить администратора'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Display name"
          placeholder="Имя"
          name="displayName"
          value={values.displayName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.displayName && errors.displayName}
        />
        <FormInput
          label="E-mail"
          placeholder="Е-mail"
          name="email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.email && errors.email}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
